
const ContractsLoading = ['$resource', function ($resource) {
    return $resource(API_URL + '/api/1.0/masters/contracts/');
}]

const ContractsMaster = ['$q', 'ContractsLoading',  function ($q, ContractsLoading) {

    var contracts= {
        items: null,

        loadContracts: function () {
            var self = this;
            var deferred = $q.defer();
            if (this.items == null)
                ContractsLoading.query(function (data) {
                    self.items = data;
                    deferred.resolve(data);
                });
            else
                deferred.resolve(self.items);

            return deferred.promise;
        }

    };

    return contracts;


}]


export {ContractsMaster, ContractsLoading}
